export class SortedBy {

	constructor(
		public value: number,
		public order: 'ascending' | 'descending',
	) {
	}

	toString = () => `${this.value},${this.order}`
}
